import Image from "common/components/Image";

import Banner from "client/common/components/content/Banner";

import { useBiFreeToyDrawer } from "../stackables";
import kongImage from "../images/kong-classic.webp";

import styles from "../styles/BiFreeToyBanner.module.less";

const BiFreeToyBanner = () => {
  const { open } = useBiFreeToyDrawer();

  return (
    <Banner.LinkButton
      type="button"
      variant="promotion-dark"
      className={styles.banner}
      onClick={open}
    >
      <Image className={styles.image} src={kongImage} alt="" />
      <Banner.Content
        label="LIMITED TIME ONLY: Get a FREE KONG with your purchase"
        description="While supplies last. Additional terms apply."
      />
    </Banner.LinkButton>
  );
};

export default BiFreeToyBanner;
